import { render, staticRenderFns } from "./SystemAssetsSelector.vue?vue&type=template&id=459693bc&"
import script from "./SystemAssetsSelector.vue?vue&type=script&lang=js&"
export * from "./SystemAssetsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports